import { create } from 'zustand';
import { fetchCoinDetails, getStabilityNotice } from '../api/coingecko';
import { formatChartDate, formatLongDate } from '../helpers/formatters';

const initialState = {
  coin: null,
  graphData: [],
  loading: false,
  error: '',
  notice: '',
};

const showStore = create((set) => ({
  ...initialState,

  reset: () => {
    set(initialState);
  },

  fetchData: async (id) => {
    set({
      loading: true,
      error: '',
      notice: '',
    });

    try {
      const result = await fetchCoinDetails(id);
      const graphData = result.data.chart.prices.map(([timestamp, price]) => ({
        date: formatChartDate(timestamp),
        fullDate: formatLongDate(timestamp),
        price,
      }));

      set({
        coin: result.data.coin,
        graphData,
        loading: false,
        notice: getStabilityNotice(result.meta),
      });
    } catch (error) {
      set({
        coin: null,
        graphData: [],
        loading: false,
        error: error.message,
        notice: '',
      });
    }
  },
}));

export default showStore;
